
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { invokeSupabaseFunctionWithFallback } from '@/utils/fallbackFetch';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;

/**
 * Специальный клиент Supabase для критически важных операций с fallback-логикой
 */
class AuthSupabaseClient {
  private client: SupabaseClient;

  constructor() {
    this.client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    });
  }

  // Проксируем все стандартные методы
  get auth() {
    return this.client.auth;
  }

  get from() {
    return this.client.from.bind(this.client);
  }

  get storage() {
    return this.client.storage;
  }

  // Специальный метод для вызова функций с fallback
  async invokeFunctionWithFallback(functionName: string, payload: any = {}) {
    try {
      // Получаем текущую сессию для авторизации
      const { data: { session } } = await this.client.auth.getSession();
      const authToken = session?.access_token;

      return await invokeSupabaseFunctionWithFallback(functionName, payload, authToken);
    } catch (error) {
      console.error(`❌ Ошибка вызова функции ${functionName}:`, error);
      throw error;
    }
  }

  // Обычный метод functions для обратной совместимости
  get functions() {
    return {
      invoke: (functionName: string, options: any = {}) => {
        console.log('🔄 Попытка вызова функции через fallback:', functionName);
        return this.invokeFunctionWithFallback(functionName, options.body || {});
      }
    };
  }
}

// Создаем единственный экземпляр
export const authSupabaseClient = new AuthSupabaseClient();

// Экспортируем стандартный клиент для обратной совместимости  
export const supabase = authSupabaseClient;

console.log('✅ Auth Supabase клиент с fallback-логикой инициализирован');
